import { HubsViewMode } from '#shared';

import { HubsByRegionList } from './HubsByRegionList';

import type { HubReportStatus } from '#entities';

interface HubsRegionClustersProps {
  hubs: HubReportStatus[];
  hubsViewMode?: HubsViewMode;
  onClickHub: (id: string) => void;
  onClickSurgeon: (regionName: string) => void;
}

export const HubsRegionClusters = ({
  hubs,
  hubsViewMode,
  onClickHub,
  onClickSurgeon,
}: HubsRegionClustersProps) => {
  const isFlat = hubsViewMode === HubsViewMode.Flat;
  const isRegion = hubsViewMode === HubsViewMode.Regions;

  return (
    <>
      {(isFlat || isRegion) && (
        <HubsByRegionList
          hubsViewMode={hubsViewMode}
          hubs={hubs}
          handleOpenHubDrawer={onClickHub}
          handleOpenSurgeonDrawer={onClickSurgeon}
        />
      )}
    </>
  );
};
